import "../style/dashboard/ExamResults.css";
import { VscChevronLeft } from "react-icons/vsc";

let ert_data = [
  {
    id: 1,
    name: "نتایج نهایی",
    line: true,
    exams: [
      {
        id: 1,
        name: "آزمون راهنمای و رانندگی ",
        date: "1400/03/29",
        result: "قبول",
        isPassed: 1,
      },
      {
        id: 2,
        name: "آزمون راهنمای و رانندگی ",
        date: "1400/03/29",
        result: "قبول",
        isPassed: 1,
      },
      {
        id: 3,
        name: "آزمون جامعه شناسی تحلیلی",
        date: "1400/03/29",
        result: "رد",
        isPassed: 2,
      },
      {
        id: 4,
        name: "آزمون راهنمای و رانندگی ",
        date: "1400/03/29",
        result: "قبول",
        isPassed: 1,
      },
    ],
  },
  {
    id: 2,
    name: "نتایج موقت",
    line: true,
    exams: [
      {
        id: 1,
        name: "آزمون راهنمای و رانندگی ",
        date: "1400/03/29",
        result: "قبول",
        isPassed: 1,
      },
      {
        id: 2,
        name: "آزمون راهنمای و رانندگی ",
        date: "1400/03/29",
        result: "قبول",
        isPassed: 1,
      },
    ],
  },
  {
    id: 3,
    name: "نتایج قرعه‌کشی",
    line: false,
    exams: [
      {
        id: 1,
        name: "آزمون راهنمای و رانندگی ",
        date: "1400/03/29",
        result: "در حال برگزاری",
        isPassed: 3,
      },
      {
        id: 2,
        name: "آزمون راهنمای و رانندگی ",
        date: "1400/03/29",
        result: "در حال برگزاری",
        isPassed: 3,
      },
    ],
  },
];

const ExamResults = () => {
  return (
    <div className="exam-result">
      <div className="exam-result-title">نتایج آزمون‌ها</div>
      <div className="exam-result-table">
        <div className="exam-result-table-titles">
          <div className="ertt-item">موضوع آزمون</div>
          <div className="ertt-item">تاریخ برگزاری</div>
          <div className="ertt-item">نتیجه</div>
        </div>
        <div className="exam-result-table-data">
          {ert_data.map((item) => (
            <div key={item.id} className="ertd-item">
              <div className="ertd-item-name">{item.name}</div>
              {item.exams.map((item) => (
                <div
                  style={
                    item.isPassed === 1
                      ? { backgroundColor: "#F5FFF6" }
                      : item.isPassed === 2
                      ? { backgroundColor: "#FFF9F5" }
                      : { backgroundColor: "#EEFCFF" }
                  }
                  key={item.id}
                  className="ertdi-item"
                >
                  <div
                    style={
                      item.isPassed === 1
                        ? { color: "#2FB100" }
                        : item.isPassed === 2
                        ? { color: "#C44000" }
                        : { color: "#35656F" }
                    }
                    className="ertdi-item-name"
                  >
                    {item.name}
                  </div>
                  <div
                    style={
                      item.isPassed === 1
                        ? { color: "#2FB100" }
                        : item.isPassed === 2
                        ? { color: "#C44000" }
                        : { color: "#35656F" }
                    }
                    className="ertdi-item-date"
                  >
                    {item.date}
                  </div>
                  <div
                    style={
                      item.isPassed === 1
                        ? { color: "#2FB100" }
                        : item.isPassed === 2
                        ? { color: "#C44000" }
                        : { color: "#35656F" }
                    }
                    className="ertdi-item-result"
                  >
                    {item.result}
                  </div>
                </div>
              ))}
              {item.line && <div className="ertd-item-line"></div>}
            </div>
          ))}
        </div>
      </div>
      <div className="exam-result-footer">
        <div className="erf-btn">
          <VscChevronLeft className="erf-btn-arrow-icon" />
          مشاهده لیست نتایج
        </div>
      </div>
    </div>
  );
};

export default ExamResults;
